import i18n from 'utils/i18n'
import type { AdminMentionsPricesFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  PRICE_INTERVAL,
  RADIO_LIST,
  SWITCHER,
  RHEOSTAT,
  offersFiltersTitle,
  offersFiltersName,
  offersFiltersKey,
  SEARCH_USERS,
  MULTISELECT_SWITCHER,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationMentionsPricesFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.eshopFilter),
    filterName:
      ADMIN_FILTERS_NAME.merchantFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.merchantFilter,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(ADMIN_FILTERS_TITLE.confidenceFilter),
    filterName:
      ADMIN_FILTERS_NAME.modelTradeOfferConfidenceFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.modelTradeOfferConfidenceFilter,
    maxFraction: 100000,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.modelVersionFilter),
    filterName:
      ADMIN_FILTERS_NAME.modelTradeOfferVersionFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.modelTradeOfferVersionFilter,
  },
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(ADMIN_FILTERS_TITLE.onlyLatestMentionFilter),
    filterName:
      ADMIN_FILTERS_NAME.onlyLatestMentionFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.onlyLatestMentionFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.aiRetailOffersFilter),
    filterName:
      ADMIN_FILTERS_NAME.aiRetailOffersFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.aiRetailOffersFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.userRetailOffersFilter),
    filterName:
      ADMIN_FILTERS_NAME.userRetailOffersFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userRetailOffersFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.hasTradeOfferDifferenceFilter),
    filterName:
      ADMIN_FILTERS_NAME.hasTradeOfferDifferenceFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.hasTradeOfferDifferenceFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.modelNewLotsFilter),
    filterName:
      ADMIN_FILTERS_NAME.modelNewLotsFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.modelNewLotsFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.userNewLotsFilter),
    filterName:
      ADMIN_FILTERS_NAME.userNewLotsFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userNewLotsFilter,
  },
  {
    type: filterTypes[PRICE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.modelPriceFilter),
    filterName:
      ADMIN_FILTERS_NAME.modelPriceFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.modelPriceFilter,
  },
  {
    type: filterTypes[PRICE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.userPriceFilter),
    filterName:
      ADMIN_FILTERS_NAME.userPriceFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userPriceFilter,
  },

  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.anomalyFilter),
    filterName:
      ADMIN_FILTERS_NAME.anomalyFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.anomalyFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isNotOkSnapshotFilter),
    filterName:
      ADMIN_FILTERS_NAME.isNotOkSnapshotFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.isNotOkSnapshotFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferStatusFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferStatusFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferStatusFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferSizeFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferSizeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferSizeFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferPackageTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferPackageTypeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferPackageTypeFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferWineLotFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferWineLotFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferWineLotFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferVatBehaviorFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferVatBehaviorFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferVatBehaviorFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferPurchaseConditionFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferPurchaseConditionFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferPurchaseConditionFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferDeliveryCostFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferDeliveryCostFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferDeliveryCostFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferVintageFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferVintageFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferVintageFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferPriceTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferPriceTypeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferPriceTypeFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isStockQuantitySetFilter),
    filterName:
      ADMIN_FILTERS_NAME.isStockQuantitySetFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.isStockQuantitySetFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.validScreenFilter),
    filterName:
      ADMIN_FILTERS_NAME.validScreenFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.validScreenFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.invalidReasonFilter),
    filterName:
      ADMIN_FILTERS_NAME.invalidReasonFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.invalidReasonFilter,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(ADMIN_FILTERS_TITLE.retailOfferCountFilter),
    filterName:
      ADMIN_FILTERS_NAME.retailOfferCountFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.retailOfferCountFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.variousQuantitiesFilter),
    filterName:
      ADMIN_FILTERS_NAME.variousQuantitiesFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.variousQuantitiesFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousStatusFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousStatusFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousStatusFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousBottleSizeFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousBottleSizeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousBottleSizeFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousPackageTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousPackageTypeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousPackageTypeFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousWineLotFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousWineLotFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousWineLotFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousPriceFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousPriceFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousPriceFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousCurrencyFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousCurrencyFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousCurrencyFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousPriceTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousPriceTypeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousPriceTypeFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousVatBehaviorFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousVatBehaviorFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousVatBehaviorFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousPurchaseConditionFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousPurchaseConditionFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousPurchaseConditionFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousDeliveryCostFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousDeliveryCostFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousDeliveryCostFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousVintageFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousVintageFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousVintageFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousScreenValidityFilter),
    filterName:
      ADMIN_FILTERS_NAME.suspiciousScreenValidityFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousScreenValidityFilter,
  },
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(ADMIN_FILTERS_TITLE.suspiciousOfferCountFilter),
    filterName: ADMIN_FILTERS_NAME.suspiciousOfferCountFilter,
    apiFilterName: ADMIN_FILTERS_KEY.suspiciousOfferCountFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineCountryFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineCountryFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.productCountryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.producerFilter),
    filterName:
      ADMIN_FILTERS_NAME.producerFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.tradeNameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.productBrandFilter),
    filterName:
      ADMIN_FILTERS_NAME.productBrandFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.productBrandFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.additionalNameFilter),
    filterName:
      ADMIN_FILTERS_NAME.additionalNameFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.additionalNameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.nationalGITypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.nationalGITypeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.nationalGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.geoIndicationFilter),
    filterName:
      ADMIN_FILTERS_NAME.geoIndicationFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.geoIndicationFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.specialClassificationFilter),
    filterName:
      ADMIN_FILTERS_NAME.specialClassificationFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.specialClassificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineTypeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineColourFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineColourFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.sweetnessTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.sweetnessTypeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.sweetnessTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.vintageFilter),
    filterName:
      ADMIN_FILTERS_NAME.vintageFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.vintageFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.kindOfWineFilter),
    filterName:
      ADMIN_FILTERS_NAME.kindOfWineFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.kindOfWineFilter,
  },
  {
    type: filterTypes[MULTISELECT_SWITCHER],
    title: i18n.t(offersFiltersTitle.grapesFilter),
    filterName: offersFiltersName.grapesFilter,
    apiFilterName: offersFiltersKey().grapesFilter,
    switchType: filterTypes[SWITCHER],
    switchFilterName: offersFiltersName.monocepageFilter,
    switchTitle: i18n.t(offersFiltersTitle.monocepageFilter),
    switchApiFilterName: 'grapeAndMonocepage',
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.bottleSizeFilter),
    filterName:
      ADMIN_FILTERS_NAME.bottleSizeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.bottleSizeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.packageTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.packageTypeFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.packageTypeFilter,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificationUserFilter),
    filterName:
      ADMIN_FILTERS_NAME.userTradeOfferUsernameFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userTradeOfferUsernameFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.createdAtFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificatedAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.tradeOfferVerificatedAtFilter satisfies AdminMentionsPricesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.tradeOfferVerificatedAtFilter,
  },
]

export const adminMentionsPricesFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationMentionsPricesFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'mentions', 'mentionsPricesFilters'],
  showResultsTextKey: 'filters.button.apply',
}
